<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const { data }: ContentBlockComponentProps<ContentType.LeadParagraph> = $props();
</script>

<p class="text-2md lg:text-lg max-w-4xl leading-[1.35em] mt-8">
	<Formatted text={data.text} />
</p>
